import * as ActionName from '../action-names';

import Global from '../../global';

export default {
  startLogin() {
    return { type: ActionName.LOGIN_IN_PROGRESS };
  },
  loginSuccess(userData) {
    return { type: ActionName.LOGIN_SUCCESS, userData };
  },
  loginFailed() {
    return { type: ActionName.LOGIN_FAILED };
  },
  logoutSuccess() {
    return { type: ActionName.LOGOUT_SUCCESS };
  },
  extendSessionSuccess(data) {
    Global.logger.warn('[AUTH] user session extended');
    return { type: ActionName.SESSION_EXTEND_SUCCESS, data };
  },
  kickUser() {
    Global.logger.warn('[AUTH] user kicked');
    return { type: ActionName.KICK_USER };
  },
  changeOddsFormat(newOddsFormat) {
    return { type: ActionName.CHANGE_ODDS_FORMAT, newOddsFormat };
  },
  updateUserContext(newUserDetails) {
    return { type: ActionName.UPDATE_USER_CONTEXT, newUserDetails };
  },
  setUserToken(token) {
    return { type: ActionName.SET_USER_TOKEN, token };
  }
};
